const renderEventTitle = series => {
  const participants = series.participants || [];
  const seriesWithoutParticipants =
    participants.length && participants.every(participant => participant.name && participant.name === 'TBD');

  return `${series.tournament.title} ${seriesWithoutParticipants ? ` - ${series.title}` : ''}`;
};

export default renderEventTitle;
